export const IMAGE_ACCEPT_STRING = 'image/*';
export const VIDEO_ACCEPT_STRING = 'video/*';
export const IMAGE_AND_VIDEO_ACCEPT_STRING = `image/*,video/*`;
